function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerLocaleKeys from '../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { ConvergentBillerTreatmentDetailsSelector, ConvergentBillerIsInPromiseToPay, ConvergentBillerCurrentPromiseToPayInstallment, ConvergentBillerIsInTreatment, ConvergentBillerSubscriberSummarySelector, IsFetchingTreatmentDetailsSelector, IsFetchingSubscriberSummarySelector, ConvergentBillerCurrentPromiseToPaySchedule } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { CurrentCustomerIdSelector, CurrentCustomerConvergentBillerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { retrieveConvergentBillerTreatmentDetails, retrieveConvergentBillerSubscriberSummary, removePromiseToPaySchedule } from '../../../reducers/actions/customer.convergent.biller.actions';
import { IsARMInMaintenanceModeSelector } from 'invision-core/src/components/warnings/warnings.selectors';
import { MetadataActions, MetadataConstants, MetadataSelectors, PermissionService } from 'invision-core';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { SUBSCRIBER_TREATMENT_ACCESS } from '../../../security.attributes';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
var TreatmentDetailsController = /*#__PURE__*/function () {
  function TreatmentDetailsController($ngRedux, uiNotificationService) {
    _classCallCheck(this, TreatmentDetailsController);
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
  }
  return _createClass(TreatmentDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          armInMaintenanceMode: IsARMInMaintenanceModeSelector(store),
          customerId: CurrentCustomerIdSelector(store),
          customerConvergentBillerId: CurrentCustomerConvergentBillerIdSelector(store),
          hasPromiseToPay: ConvergentBillerIsInPromiseToPay(store),
          isFetchingTreatmentDetails: IsFetchingTreatmentDetailsSelector(store),
          isFetchingSubscriberSummary: IsFetchingSubscriberSummarySelector(store),
          isInTreatment: ConvergentBillerIsInTreatment(store),
          periodTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PeriodType, store),
          promiseToPayDetails: ConvergentBillerCurrentPromiseToPayInstallment(store),
          subscriberSummary: ConvergentBillerSubscriberSummarySelector(store),
          treatmentDetails: ConvergentBillerTreatmentDetailsSelector(store),
          promiseToPaySchedule: ConvergentBillerCurrentPromiseToPaySchedule(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveConvergentBillerTreatmentDetails: retrieveConvergentBillerTreatmentDetails,
        removePromiseToPaySchedule: removePromiseToPaySchedule,
        fetchPeriodTypes: MetadataActions.codes.fetchPeriodTypes
      };
      this.CustomerLocaleKeys = CustomerLocaleKeys;
      this.isChangeStepEscalationCalled = false;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.customerConvergentBillerId && !this.state.isFetchingTreatmentDetails) {
        this.actions.retrieveConvergentBillerTreatmentDetails(this.state.customerId);
      }
      if (!this.state.periodTypesLoaded) {
        this.actions.fetchPeriodTypes();
      }
      if (this.state.customerConvergentBillerId && !this.state.isFetchingSubscriberSummary) {
        this.actions.retrieveConvergentBillerSubscriberSummary(this.state.customerId);
      }
      this.createPromiseToPayConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var open = _ref.api.open;
          _this.openCreatePromiseToPayPopup = open;
        }
      };
      this.changeStepConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var open = _ref2.api.open;
          _this.openChangeStepPopup = open;
        }
      };
      this.promiseToPayScheduleConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var open = _ref3.api.open;
          _this.openPromiseToPaySchedulePopup = open;
        }
      };
      this.removePromiseToPayScheduleConfirmPopUpConfig = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.removePromiseToPayScheduleConfirmPopUp = evt.api;
        }
      };
      this.refreshData = function () {
        _this.actions.retrieveConvergentBillerSubscriberSummary(_this.state.customerId);
        _this.actions.retrieveConvergentBillerTreatmentDetails(_this.state.customerId);
      };
      this.changeStepSuccess = function (isEscalation) {
        if (isEscalation) {
          _this.isChangeStepEscalationCalled = true;
        } else {
          _this.refreshTreatmentDetails();
        }
      };
      this.refreshTreatmentDetails = function () {
        _this.actions.retrieveConvergentBillerTreatmentDetails(_this.state.customerId);
        _this.isChangeStepEscalationCalled = false;
      };
      this.hasTreatmentAdminAccess = function () {
        return PermissionService.hasAdminAccess(_this.state.userSecurityAttributes, SUBSCRIBER_TREATMENT_ACCESS);
      };
      this.hasTreatmentReadAccess = function () {
        return PermissionService.hasReadAccess(_this.state.userSecurityAttributes, SUBSCRIBER_TREATMENT_ACCESS);
      };
      this.removePromiseToPaySchedule = function (isConfirmed) {
        if (isConfirmed) {
          _this.actions.removePromiseToPaySchedule(_this.state.customerId).then(function () {
            _this.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.TREATMENT_DETAILS.REMOVE_PROMISE_TO_PAY_SUCCESS_MESSAGE), null, {
              timeOut: NOTIFICATION_TIME_LENGTH
            });
            _this.actions.retrieveConvergentBillerSubscriberSummary(_this.state.customerId);
            _this.closeRemovePromiseToPaySchedulePopup();
          }).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
            _this.closeRemovePromiseToPaySchedulePopup();
          });
        } else {
          _this.closeRemovePromiseToPaySchedulePopup();
        }
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "openRemovePromiseToPaySchedulePopup",
    value: function openRemovePromiseToPaySchedulePopup() {
      this.removePromiseToPayScheduleConfirmPopUp.open();
    }
  }, {
    key: "closeRemovePromiseToPaySchedulePopup",
    value: function closeRemovePromiseToPaySchedulePopup() {
      this.removePromiseToPayScheduleConfirmPopUp.close();
    }
  }, {
    key: "getPromiseToPayStatusKey",
    value: function getPromiseToPayStatusKey() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        PromiseStatus = _ref4.PromiseStatus;
      var subKey;
      switch (PromiseStatus) {
        case 0:
          subKey = 'OPEN';
          break;
        case 1:
          subKey = 'COMPLETED';
          break;
        case 2:
          subKey = 'BROKEN';
          break;
        default:
          subKey = 'NA';
          break;
      }
      return CustomerLocaleKeys.TREATMENT_DETAILS.PROMISE_TO_PAY_STATUS[subKey];
    }
  }, {
    key: "shouldShowChangeStep",
    get: function get() {
      return this.state && this.state.treatmentDetails.NextStepNumber !== 0 && !this.isChangeStepEscalationCalled;
    }
  }, {
    key: "isContentLoading",
    get: function get() {
      return this.state && (this.state.isFetchingTreatmentDetails || this.state.isFetchingSubscriberSummary || this.isNavigatingToOverview);
    }
  }]);
}();
export default {
  template: require('./treatment.details.html'),
  controller: TreatmentDetailsController,
  controllerAs: 'TreatmentDetails'
};